import { getItem, setItem } from '@gig/magic-common';
import { VWO_INSTANCE } from '@gig/magic-messages';
import { v4 } from 'uuid';
import vwoSdk from 'vwo-node-sdk';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const getVariant = (config) => __async(undefined, null, function* () {
  let abUserId = getItem("ab-user-id");
  if (!abUserId) {
    const id = v4();
    abUserId = id;
    setItem("ab-user-id", id);
  }
  const settingsFile = yield vwoSdk.getSettingsFile(config.accountId, config.sdkKey);
  const vwoInstance = yield vwoSdk.launch({ settingsFile });
  const variant = yield vwoInstance.activate(config.campaignKey, `${abUserId}`);
  window.eventBus.publish(VWO_INSTANCE, vwoInstance);
  return variant;
});

export { getVariant };
